import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpfleet0getGetFleetResponseSchema = jsonObject
export type tcpfleet0getGetFleetResponse = z.infer<typeof tcpfleet0getGetFleetResponseSchema>
export const tcpfleet0getGetFleetHealthResponseSchema = jsonObject
export type tcpfleet0getGetFleetHealthResponse = z.infer<typeof tcpfleet0getGetFleetHealthResponseSchema>
